function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ga4Analysis, sources } from "@t8891/helper";
import { trackApi, ignoreApiList, TRACK_SUPPORT_PAGE_TYPE } from "../config";
import { deviceSource, getParamsForUrl, isPageRoute, getValueByPath, extractStringAfterFirstDot, getCurrentJson, setCookieSpm, isMatchLink, findCurrentParam } from "../utils";
import fetchTest from "../utils/fetchTest";
import exposureListen from "./exposureListen";
import Cookies from "js-cookie";
import clickListen from "./clickListen";
var Tracking = /*#__PURE__*/function () {
  function Tracking(props) {
    var _this = this;
    _classCallCheck(this, Tracking);
    var _a, _b;
    this.trackManual = [];
    /** xpath匹配到元素 */
    this.eventObj = Object;
    /** 当前页面url */
    this.currentUrl = "";
    /** utm json */
    this.utmHashMap = {};
    /**
     * @description 获取属于当前页的点击事件
     */
    this.filterCurrentAction = function () {
      var self = _this;
      self.currentClickJson = [];
      self.currentExposuresJson = [];
      self.currentClickJson = getCurrentJson(self, self.clickJson);
      self.currentExposuresJson = getCurrentJson(self, self.exposuresJson);
      // 绑定曝光事件
      self.bindEvent({
        currentJSon: self.currentExposuresJson,
        listenEvent: exposureListen
      });
      // 绑定点击事件
      self.bindEvent({
        currentJSon: self.currentClickJson,
        listenEvent: clickListen
      });
    };
    /**
     * @description 获取静态json文件
     */
    this.fetchTrack = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var response, res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch(_this.options.trackApi);
          case 3:
            response = _context.sent;
            _context.next = 6;
            return response.json();
          case 6:
            res = _context.sent;
            _this.json = res.events;
            _this.defaultEventsJson = (res === null || res === void 0 ? void 0 : res.default_events) || [];
            // localStorage.setItem(TRACK_LOCAL_STORAGE_CONFIG_JSON, JSON.stringify(res.events));
            _this.resolutionJSON(res.events);
            // if (this.pageviewJson.length === 0) {
            // }
            _this.handleLocationChange();
            // 获取属于当前页的点击事件和曝光事件
            _this.filterCurrentAction();
            _this.initExposureListen();
            _context.next = 19;
            break;
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](0);
            localStorage.clear();
            console.log(_context.t0);
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 15]]);
    }));
    /**
     * @description 初始化 utm json
     */
    // private async initUtmHashMap() {
    //   const response = await fetch("https://assets.8891.com.tw/track/source_medium.json");
    //   const res = await response.json();
    // }
    this.resolutionJSON = function (responseJson) {
      var self = _this;
      // const jsonStorage = localStorage.getItem(TRACK_LOCAL_STORAGE_CONFIG_JSON);
      var jsonParse = responseJson;
      if (Array.isArray(jsonParse) && jsonParse.length > 0) {
        var exposuresJson = [],
          clickJson = [],
          pageviewJson = [];
        jsonParse.map(function (item) {
          var type = item.trigger.type;
          if (["exposure", "global_pageview", "global_exposure"].includes(type)) {
            exposuresJson.push(item);
            return;
          }
          if (type === "pageview") {
            pageviewJson.push(item);
            return;
          }
          if (["action", "global_action"].includes(type)) {
            clickJson.push(item);
            return;
          }
        });
        self.locationHref = window.location.href;
        self.exposuresJson = exposuresJson;
        self.pageviewJson = pageviewJson;
        self.clickJson = clickJson;
        // 监听历史Url前进后退
        self.initHistoryListen();
        // 监听路由变化
        self.initRouteListen();
      }
    };
    /**
     * @description 增加點擊手埋匹配 next_spm 並上報
     */
    this.click = function (next_spm) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var result = _this.clickJson.find(function (item) {
        return item.event.params && item.event.params.next_spm === next_spm;
      });
      var mergeParams = Object.assign(Object.assign({}, result.event.params), params);
      result.event.params = mergeParams;
      _this.sendEvent(result.event);
    };
    /**
     * @description 增加曝光手埋匹配 next_spm 並上報
     */
    this.exposure = function (next_spm) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!_this.exposuresJson || _this.exposuresJson.length === 0) {
        setTimeout(function () {
          _this.exposure(next_spm, params);
        }, 1000);
        return;
      }
      var result = _this.exposuresJson.find(function (item) {
        return item.event.params && item.event.params.next_spm === next_spm;
      });
      var mergeParams = Object.assign(Object.assign({}, result.event.params), params);
      result.event.params = mergeParams;
      _this.sendEvent(result.event);
    };
    /**
     * @description 獲取手埋的next_spm 匹配 trackingJSON 獲取對應的 event 並上報
     */
    this.trackEvent = function () {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!_this.exposuresJson || _this.exposuresJson.length === 0) {
        setTimeout(function () {
          _this.trackEvent(params);
        }, 1000);
        return;
      }
      var currentParam = findCurrentParam(params, _this.clickJson, _this.exposuresJson);
      _this.sendEvent(currentParam);
    };
    /**
     * @description 上报事件
     */
    this.sendEvent = function () {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _a, _b;
      var _this$options = _this.options,
        debug = _this$options.debug,
        source = _this$options.source;
      var spm_url = getParamsForUrl("spm");
      var mergeParams = Object.assign(Object.assign({}, _this.params), params);
      // 需要动态获取的参数
      var getDynamicGaParams = {};
      try {
        getDynamicGaParams = _this.options.getDynamicGaParams();
      } catch (e) {
        console.error(e);
      }
      var updateParams = Object.assign(Object.assign(Object.assign(Object.assign({}, mergeParams.params), {
        spm: spm_url || Cookies.get("TRACK_LOCAL_STORAGE_NEXT_SPM") || "",
        page_route: window.page_route || "",
        device_id: (_b = (_a = localStorage.getItem("UUID")) !== null && _a !== void 0 ? _a : localStorage.getItem("uuid")) !== null && _b !== void 0 ? _b : "",
        sub_platform: source
      }), _this.options.gaParams), getDynamicGaParams);
      try {
        var isLogTracking = Cookies.get("tracking");
        var trackWorkId = Cookies.get("track_work_id");
        if (debug || !!isLogTracking || !!trackWorkId) {
          if (!window.gtag) {
            console.log("%c gtag\u5C1A\u672A\u914D\u7F6E", "color: red; font-weight: bold");
            return;
          } else if (Object.keys(mergeParams).length === 0) {
            console.log("%c \u672A\u5339\u914D\u5230\u5C0D\u61C9\u7684\u6578\u64DA", "color: red; font-weight: bold");
            return;
          }
          var _mergeParams$name = mergeParams.name,
            name = _mergeParams$name === void 0 ? "" : _mergeParams$name;
          var color = name === "browse" ? "#3264FF" : name.includes("exposure") ? "green" : "#f87f15";
          console.log("%c ".concat(name, " ").concat(JSON.stringify(updateParams)), "color: ".concat(color, "; font-weight: bold"));
          fetchTest({
            name: name,
            data: updateParams
          });
          if (isLogTracking === "table") {
            console.table(Object.assign({
              eventName: name
            }, updateParams));
          }
          //测试环境发送给测试接口
        }
        setTimeout(function () {
          _this.sendByPlatform({
            event_name: mergeParams.name || "unknown",
            params: updateParams
          });
        }, 0);
      } catch (err) {
        console.log(err.message);
      }
    };
    /**
     * @description page view 时上报数据
     */
    this.handleLocationChange = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var self, current, isUrlAndPageRoute, i, trigger, _i, _trigger, isUrlXpath;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            self = _this;
            if (!(_this.currentUrl === location.href)) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return");
          case 3:
            current = {
              wait_meta_dict: [],
              event: {
                name: "browse",
                params: {
                  screen_name: "未知",
                  page_old_name: "默認",
                  page_name: "未知",
                  page_type: "默認統計",
                  page_channel: "未知",
                  page_sub_channel: "未知",
                  page_business: "未知",
                  page_module: "未知",
                  page_sub_module: "未知",
                  version_id: "未知"
                }
              },
              trigger: {
                page_id: "未知",
                type: "pageview",
                condition_type: "未知"
              }
            };
            isUrlAndPageRoute = false; // 匹配 page_route 路由
            i = 0;
          case 6:
            if (!(self.pageviewJson.length > i)) {
              _context2.next = 16;
              break;
            }
            trigger = self.pageviewJson[i].trigger;
            if (!(trigger.type === "pageview")) {
              _context2.next = 13;
              break;
            }
            isUrlAndPageRoute = isPageRoute({
              pageId: trigger.page_id,
              pageRoute: window === null || window === void 0 ? void 0 : window.page_route
            });
            if (!isUrlAndPageRoute) {
              _context2.next = 13;
              break;
            }
            current = self.pageviewJson[i];
            return _context2.abrupt("break", 16);
          case 13:
            i++;
            _context2.next = 6;
            break;
          case 16:
            if (isUrlAndPageRoute) {
              _context2.next = 29;
              break;
            }
            _i = 0;
          case 18:
            if (!(self.pageviewJson.length > _i)) {
              _context2.next = 29;
              break;
            }
            _trigger = self.pageviewJson[_i].trigger;
            if (!(_trigger.type === "pageview")) {
              _context2.next = 26;
              break;
            }
            isUrlXpath = isMatchLink(_trigger.page_id, _this.locationHref);
            isUrlAndPageRoute = !!isUrlXpath;
            if (!isUrlAndPageRoute) {
              _context2.next = 26;
              break;
            }
            current = self.pageviewJson[_i];
            return _context2.abrupt("break", 29);
          case 26:
            _i++;
            _context2.next = 18;
            break;
          case 29:
            _this.currentUrl = window.location.href;
            // 如果没有附加属性则直接上报,如果没有匹配中默认上报未知
            if (Array.isArray(current.wait_meta_dict) && current.wait_meta_dict.length === 0) {
              _this.params = current.event;
              _this.sendEvent();
            }
            // 如果有, 获取附加属性上报
            if (Array.isArray(current.wait_meta_dict) && current.wait_meta_dict.length > 0) {
              _this.params = {
                name: current.event.name,
                params: Object.assign(Object.assign({}, _this.parseWaitMetaDictFields(current)), current.event.params)
              };
              _this.sendEvent();
            }
          case 32:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    var sources = deviceSource();
    this.options = Object.assign({
      trackApi: (_a = props === null || props === void 0 ? void 0 : props.trackApi) !== null && _a !== void 0 ? _a : trackApi,
      ignoreApiList: (_b = props === null || props === void 0 ? void 0 : props.ignoreApiList) !== null && _b !== void 0 ? _b : ignoreApiList,
      source: props.source || sources.os,
      debug: false,
      gaParams: {},
      getDynamicGaParams: function getDynamicGaParams() {
        return {};
      }
    }, props);
    this.json = [];
    this.pageviewJson = [];
    this.TRACK_LOCAL_STORAGE_NEXT_SPM = "";
    this.clickJson = [];
    this.currentClickJson = [];
    this.currentExposuresJson = [];
    this.locationHref = "";
    this.defaultEventsJson = [];
    this.exposuresJson = [];
    this.params = {
      name: "",
      params: {},
      device_id: "",
      sub_platform: ""
    };
    this.eventObj = {};
    // this.resolutionJSON();
    this.fetchTrack();
  }
  /**
   * @description 初始化曝光相关事件监听
   */
  return _createClass(Tracking, [{
    key: "initExposureListen",
    value: function initExposureListen() {
      var self = this;
      // 创建一个观察器
      var targetNode = document.querySelector("body");
      var observerMonitor = new MutationObserver(function (mutationsList, observer) {
        // 绑定曝光事件
        self.bindEvent({
          currentJSon: self.currentExposuresJson,
          listenEvent: exposureListen
        });
        // 绑定点击事件
        self.bindEvent({
          currentJSon: self.currentClickJson,
          listenEvent: clickListen
        });
      });
      // 将观察器绑定到目标元素上，并指定要观察的变化类型
      observerMonitor.observe(targetNode, {
        childList: true,
        subtree: true
      });
    }
    /**
     * @description 绑定点击/曝光事件
     */
  }, {
    key: "bindEvent",
    value: function bindEvent(_ref3) {
      var currentJSon = _ref3.currentJSon,
        listenEvent = _ref3.listenEvent;
      var self = this;
      currentJSon === null || currentJSon === void 0 ? void 0 : currentJSon.forEach(function (item) {
        var condition = item.trigger.condition;
        // 配置是否存在当前页面曝光 XPath
        if ((condition === null || condition === void 0 ? void 0 : condition.value) !== "no") {
          try {
            var xpathResult = document.evaluate(condition.value, document, null, XPathResult.ORDERED_NODE_SNAPSHOT_TYPE, null);
            for (var i = 0; i < xpathResult.snapshotLength; i++) {
              var element = xpathResult.snapshotItem(i);
              listenEvent({
                $element: element,
                self: self,
                item: item
              });
            }
          } catch (e) {
            console.error("Invalid XPath expression:", e);
          }
        }
      });
    }
    /**
     * @description 初始化location相关事件监听
     */
  }, {
    key: "initHistoryListen",
    value: function initHistoryListen() {
      var _window = window,
        history = _window.history;
      try {
        history.pushState = function (fn) {
          return function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            var context = fn.apply(history, args);
            window.dispatchEvent(new CustomEvent("pushstate"));
            window.dispatchEvent(new CustomEvent("changeLocation"));
            return context;
          };
        }(history.pushState);
        history.replaceState = function (fn) {
          return function () {
            for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }
            var context = fn.apply(history, args);
            window.dispatchEvent(new CustomEvent("replacestate"));
            window.dispatchEvent(new CustomEvent("changeLocation"));
            return context;
          };
        }(history.replaceState);
        window.addEventListener("popstate", function () {
          Cookies.set("TRACK_LOCAL_STORAGE_NEXT_SPM", "", {
            expires: -1
          });
          window.dispatchEvent(new CustomEvent("changeLocation"));
        });
      } catch (e) {
        console.log(e);
      }
    }
    /**
     * @description 初始化相关事件监听
     */
  }, {
    key: "initRouteListen",
    value: function initRouteListen() {
      var _this2 = this;
      var self = this;
      // document.addEventListener("click", this.handleClick.bind(this), true);
      window.addEventListener("beforeunload", function (event) {
        // 预防使用 a 标签当前页强刷新导致spm没有存储
        setCookieSpm(self);
      });
      // 路由切换触发
      window.addEventListener("changeLocation", function (url) {
        setTimeout(function () {
          _this2.locationHref = window.location.href;
          setCookieSpm(self);
          _this2.handleLocationChange();
          _this2.filterCurrentAction();
        }, 300);
        //TODO: pv 上报待优化
        // setTimeout(() => {
        // }, 1000);
      });
      // window.onunload = () => {
      //   document.removeEventListener("click", this.handleClick);
      // };
    }
    /**
     * @description 根据平台出发发送事件
     */
  }, {
    key: "sendByPlatform",
    value: function sendByPlatform(_ref4) {
      var event_name = _ref4.event_name,
        params = _ref4.params;
      try {
        if (!!sources && sources.system !== "web") {
          delete params.device_id;
          ga4Analysis({
            event: event_name,
            params: Object.assign(Object.assign({}, params), {
              origin_platform: "webview"
            })
          });
          return;
        }
        window.gtag("event", event_name, params);
      } catch (e) {
        console.error(e);
      }
    }
    /**
     * @description 通过数据来源，获取页面数据
     * @param { IMetaDictField } fields
     */
  }, {
    key: "getPageDataBySource",
    value: function getPageDataBySource(fields) {
      switch (fields.source) {
        case "document":
          if (fields.value === "innerText") {
            return this.eventObj.innerText;
          }
          return this.eventObj.dataset[fields.value];
        case "pathname":
          break;
        case "urlParams":
          return getParamsForUrl(fields.value);
        case "window":
          return getValueByPath(fields.value);
        default:
          return "";
      }
    }
    /**
     * @description 字符串模板类型获取页面数据方式
     * @example
     *    如：{ key: "relate_id", source: "window", value:  value: "xxx-dd_xx_{document.query.type}_{window.query.id}" } ，
     *    返回：{ relate_id: "xxx-dd_xx_2_17075" }
     * @param { IMetaDictField } fields
     */
  }, {
    key: "getFormateFieldsForTemplate",
    value: function getFormateFieldsForTemplate(fields) {
      var _this3 = this;
      try {
        var regex = /\{([^{}]*)\}/g;
        var templateValue = fields.value.replace(regex, function (match, p1) {
          var realSource = p1.split(".")[0];
          var realValue = extractStringAfterFirstDot(p1);
          if (TRACK_SUPPORT_PAGE_TYPE.includes(realSource)) {
            var value = _this3.getPageDataBySource(Object.assign(Object.assign({}, fields), {
              source: realSource,
              value: realValue
            }));
            return value !== null && value !== void 0 ? value : "";
          }
          return match;
        });
        return _defineProperty({}, fields.key, templateValue);
      } catch (e) {
        console.error(e);
        return {};
      }
    }
    /**
     * @description 默认获取页面数据方式
     * @example
     *   如：{ key: "relate_id", source: "window", value: "query.id" } ，
     *   返回：{ relate_id: "123" }
     * @param { IMetaDictField } fields
     */
  }, {
    key: "getFormateFieldsForDefault",
    value: function getFormateFieldsForDefault(fields) {
      var _a;
      return _defineProperty({}, fields.key, (_a = this.getPageDataBySource(fields)) !== null && _a !== void 0 ? _a : {});
    }
  }, {
    key: "parseWaitMetaDictFields",
    value: function parseWaitMetaDictFields(item) {
      var _this4 = this;
      var wait_meta_dict = item.wait_meta_dict;
      if (Array.isArray(wait_meta_dict) && !wait_meta_dict.length || !Array.isArray(wait_meta_dict)) return {};
      var overtimeMap = {};
      wait_meta_dict.forEach(function (dictItem) {
        var fields = dictItem.fields;
        var mapItem = fields.reduce(function (ret, cur, index) {
          var recordObj = ret;
          // 支持 { value: "xxx-dd_xx_{document.query.type}_{window.query.id}" } 的 template 形式取值
          if (cur.source === "template") {
            // 如果不是模板字符串，直接返回
            if (!/{.*}/.test(cur.value)) {
              return recordObj;
            }
            recordObj = Object.assign(Object.assign({}, ret), _this4.getFormateFieldsForTemplate(cur));
          } else {
            // 默认方式取值
            recordObj = Object.assign(Object.assign({}, ret), _this4.getFormateFieldsForDefault(cur));
          }
          return recordObj;
        }, {});
        overtimeMap = Object.assign(Object.assign({}, overtimeMap), mapItem);
      });
      return overtimeMap;
    }
  }]);
}();
export default Tracking;